<script lang="ts">
    import { Creatures } from "./store";
    import { UI, showBestiary, showEncounters } from "./ui.store";
</script>

<button class:active={$UI.showBestiary} on:click={showBestiary}
    >Bestiary ({$Creatures.length} Creatures)</button
>
<button class:active={!$UI.showBestiary} on:click={showEncounters}
    >Encounters</button
>

<style>
    button {
        color: white;
        transition: background-color 0.3s ease;
        background-color: #000;
        outline: none;
        width: 100%;
        font-size: 1.25rem;
        padding: 4px;
        padding-left: 16px;
        height: 2.3rem;
        line-height: 1.5rem;
        min-width: fit-content;
        box-sizing: border-box;
    }
    button.active {
        background-color: #9c0719;
    }
    button:hover:not(.active) {
        background-color: #5d0610;
    }
</style>
